<template>
  <Select
    :items="canais"
    :selectedItem="filter.canal"
    label="Canal"
    searchPlaceholder="Buscar canal"
    @atualizar="atualizar"
    :filtro_id="filtro.filtro"
    :path="path"
  />
</template>
<script>
import Select from '../../components/Select.vue';
export default {
  components: {
    Select,
  },
  props: {
    filtro: {
      type: Object,
      required: true,
    },
    path: {
      type: String,
      required: true
    },
    initialState: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      filter: {
        canal: {
          id: "",
          name: "",
        },
      },
      canais: this.filtro.opcoes || [],
    };
  },
  methods: {
    atualizar(canal) {
      this.filter.canal = canal;

      this.$aplicaFiltroEmURL(this.filtro.filtro, this.filter.canal.id, this.path);
      this.$store.commit('addFiltro', this.filtro);
      this.$store.commit('addFiltroAplicado', {
        filtro: this.filtro.filtro,
        valor: this.filter.canal.id
      });
    },
  },
  mounted() {
    const filtroAplicado = this.$store.state.filtroAplicados[this.filtro.filtro];
    this.$renderFiltroSelect(filtroAplicado, this.canais, this.filter.canal);
  }
}
</script>
